export const LIST_STATION_SUMMARY_REQUEST = 'LIST_STATION_SUMMARY_REQUEST'
export const LIST_STATION_SUMMARY_SUCCESS = 'LIST_STATION_SUMMARY_SUCCESS'
export const LIST_STATION_SUMMARY_FAIL = 'LIST_STATION_SUMMARY_FAIL'

export const LIST_SAMPLE_SUMMARY_REQUEST = 'LIST_SAMPLE_SUMMARY_REQUEST'
export const LIST_SAMPLE_SUMMARY_SUCCESS = 'LIST_SAMPLE_SUMMARY_SUCCESS'
export const LIST_SAMPLE_SUMMARY_FAIL = 'LIST_SAMPLE_SUMMARY_FAIL'

export const LIST_CHECKIN_SAMPLE_REQUEST = 'LIST_CHECKIN_SAMPLE_REQUEST'
export const LIST_CHECKIN_SAMPLE_SUCCESS = 'LIST_CHECKIN_SAMPLE_SUCCESS'
export const LIST_CHECKIN_SAMPLE_FAIL = 'LIST_CHECKIN_SAMPLE_FAIL'

export const EXPORT_CHECKIN_REQUEST = 'EXPORT_CHECKIN_REQUEST'
export const EXPORT_CHECKIN_SUCCESS = 'EXPORT_CHECKIN_SUCCESS'
export const EXPORT_CHECKIN_FAIL = 'EXPORT_CHECKIN_FAIL'

export const DELETE_CHECKIN_REQUEST = 'DELETE_CHECKIN_REQUEST'
export const DELETE_CHECKIN_SUCCESS = 'DELETE_CHECKIN_SUCCESS'
export const DELETE_CHECKIN_FAIL = 'DELETE_CHECKIN_FAIL'

export const GET_DATA_CHECKIN_REQUEST = 'GET_DATA_CHECKIN_REQUEST'
export const GET_DATA_CHECKIN_SUCCESS = 'GET_DATA_CHECKIN_SUCCESS'
export const GET_DATA_CHECKIN_FAIL = 'GET_DATA_CHECKIN_FAIL'

export const CALL_PATIENT_CHECKIN_REQUEST = 'CALL_PATIENT_CHECKIN_REQUEST'
export const CALL_PATIENT_CHECKIN_SUCCESS = 'CALL_PATIENT_CHECKIN_SUCCESS'
export const CALL_PATIENT_CHECKIN_FAIL = 'CALL_PATIENT_CHECKIN_FAIL'

export const SUBMIT_CHECKIN_REQUEST = 'SUBMIT_CHECKIN_REQUEST'
export const SUBMIT_CHECKIN_SUCCESS = 'SUBMIT_CHECKIN_SUCCESS'
export const SUBMIT_CHECKIN_FAIL = 'SUBMIT_CHECKIN_FAIL'

export const SAVE_PRESCRIPTION_REQUEST = 'SAVE_PRESCRIPTION_REQUEST'
export const SAVE_PRESCRIPTION_SUCCESS = 'SAVE_PRESCRIPTION_SUCCESS'
export const SAVE_PRESCRIPTION_FAIL = 'SAVE_PRESCRIPTION_FAIL'
export const DELETE_PRESCRIPTION_REQUEST = 'DELETE_PRESCRIPTION_REQUEST'
export const DELETE_PRESCRIPTION_SUCCESS = 'DELETE_PRESCRIPTION_SUCCESS'
export const DELETE_PRESCRIPTION_FAIL = 'DELETE_PRESCRIPTION_FAIL'

export const GET_DATA_SPECIMENS_REQUEST = 'GET_DATA_SPECIMENS_REQUEST'
export const GET_DATA_SPECIMENS_SUCCESS = 'GET_DATA_SPECIMENS_SUCCESS'
export const GET_DATA_SPECIMENS_FAIL = 'GET_DATA_SPECIMENS_FAIL'

export const GET_MEDICAL_RESUME_REQUEST = 'GET_MEDICAL_RESUME_REQUEST'
export const GET_MEDICAL_RESUME_SUCCESS = 'GET_MEDICAL_RESUME_SUCCESS'
export const GET_MEDICAL_RESUME_FAIL = 'GET_MEDICAL_RESUME_FAIL'

export const LOADING_SPECIMENS_REQUEST = 'LOADING_SPECIMENS_REQUEST'
export const LOADING_SPECIMENS_SUCCESS = 'LOADING_SPECIMENS_SUCCESS'
export const LOADING_SPECIMENS_FAIL = 'LOADING_SPECIMENS_FAIL'

export const GET_DATA_CHECKIN_NOLOADING_REQUEST =
  'GET_DATA_CHECKIN_NOLOADING_REQUEST'
export const GET_DATA_CHECKIN_NOLOADING_SUCCESS =
  'GET_DATA_CHECKIN_NOLOADING_SUCCESS'
export const GET_DATA_CHECKIN_NOLOADING_FAIL = 'GET_DATA_CHECKIN_NOLOADING_FAIL'

export const GET_SUMMARY_PENDING_NOTCHECK_REQUEST =
  'GET_SUMMARY_PENDING_NOTCHECK_REQUEST'
export const GET_SUMMARY_PENDING_NOTCHECK_SUCCESS =
  'GET_SUMMARY_PENDING_NOTCHECK_SUCCESS'
export const GET_SUMMARY_PENDING_NOTCHECK_FAIL =
  'GET_SUMMARY_PENDING_NOTCHECK_FAIL'

export const GET_ALL_MEDICAL_INFO_REQUEST =
  'GET_ALL_MEDICAL_INFO_REQUEST'
export const GET_ALL_MEDICAL_INFO_SUCCESS =
  'GET_ALL_MEDICAL_INFO_SUCCESS'
export const GET_ALL_MEDICAL_INFO_FAIL =
  'GET_ALL_MEDICAL_INFO_FAIL'
  
export const GET_LIST_EXPORT_REQUEST = 'GET_LIST_EXPORT_REQUEST'
export const GET_LIST_EXPORT_SUCCESS = 'GET_LIST_EXPORT_SUCCESS'
export const GET_LIST_EXPORT_FAIL = 'GET_LIST_EXPORT_FAIL'

export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const CLEAR_DATA_CHECKIN = 'CLEAR_DATA_CHECKIN'

export const DOWNLOAD_CHECKIN_REQUEST = 'DOWNLOAD_CHECKIN_REQUEST'
export const DOWNLOAD_CHECKIN_SUCCESS = 'DOWNLOAD_CHECKIN_SUCCESS'
export const DOWNLOAD_CHECKIN_FAIL = 'DOWNLOAD_CHECKIN_FAIL'

export const GET_LIST_RAPT_CPPT_REQUEST = 'GET_LIST_RAPT_CPPT_REQUEST'
export const GET_LIST_RAPT_CPPT_SUCCESS = 'GET_LIST_RAPT_CPPT_SUCCESS'
export const GET_LIST_RAPT_CPPT_FAIL = 'GET_LIST_RAPT_CPPT_FAIL'

export const GET_DETAIL_RAPT_CPPT_REQUEST = 'GET_DETAIL_RAPT_CPPT_REQUEST'
export const GET_DETAIL_RAPT_CPPT_SUCCESS = 'GET_DETAIL_RAPT_CPPT_SUCCESS'
export const GET_DETAIL_RAPT_CPPT_FAIL = 'GET_DETAIL_RAPT_CPPT_FAIL'

export const POST_RAPT_CPPT_REQUEST = 'POST_RAPT_CPPT_REQUEST'
export const POST_RAPT_CPPT_SUCCESS = 'POST_RAPT_CPPT_SUCCESS'
export const POST_RAPT_CPPT_FAIL = 'POST_RAPT_CPPT_FAIL'

export const GET_MEDICAL_DATA_SUMMARIES_REQUEST = 'GET_MEDICAL_DATA_SUMMARIES_REQUEST'
export const GET_MEDICAL_DATA_SUMMARIES_SUCCESS = 'GET_MEDICAL_DATA_SUMMARIES_SUCCESS'
export const GET_MEDICAL_DATA_SUMMARIES_FAIL = 'GET_MEDICAL_DATA_SUMMARIES_FAIL'

export const PATCH_RAPT_CPPT_REQUEST = 'PATCH_RAPT_CPPT_REQUEST'
export const PATCH_RAPT_CPPT_SUCCESS = 'PATCH_RAPT_CPPT_SUCCESS'
export const PATCH_RAPT_CPPT_FAIL = 'PATCH_RAPT_CPPT_FAIL'

export const DELETE_RAPT_CPPT_REQUEST = 'DELETE_RAPT_CPPT_REQUEST'
export const DELETE_RAPT_CPPT_SUCCESS = 'DELETE_RAPT_CPPT_SUCCESS'
export const DELETE_RAPT_CPPT_FAIL = 'DELETE_RAPT_CPPT_FAIL'

export const VERIFY_RAPT_CPPT_REQUEST = 'VERIFY_RAPT_CPPT_REQUEST'
export const VERIFY_RAPT_CPPT_SUCCESS = 'VERIFY_RAPT_CPPT_SUCCESS'
export const VERIFY_RAPT_CPPT_FAIL = 'VERIFY_RAPT_CPPT_FAIL'

export const DUPLICATE_RAPT_CPPT_REQUEST = 'DUPLICATE_RAPT_CPPT_REQUEST'
export const DUPLICATE_RAPT_CPPT_SUCCESS = 'DUPLICATE_RAPT_CPPT_SUCCESS'
export const DUPLICATE_RAPT_CPPT_FAIL = 'DUPLICATE_RAPT_CPPT_FAIL'

export const GET_HISTORY_RAPT_CPPT_REQUEST = 'GET_HISTORY_RAPT_CPPT_REQUEST'
export const GET_HISTORY_RAPT_CPPT_SUCCESS = 'GET_HISTORY_RAPT_CPPT_SUCCESS'
export const GET_HISTORY_RAPT_CPPT_FAIL = 'GET_HISTORY_RAPT_CPPT_FAIL'

export const GET_MEDICAL_DIAGNOSIS_SUMMARIES_REQUEST = 'GET_MEDICAL_DIAGNOSIS_SUMMARIES_REQUEST'
export const GET_MEDICAL_DIAGNOSIS_SUMMARIES_SUCCESS = 'GET_MEDICAL_DIAGNOSIS_SUMMARIES_SUCCESS'
export const GET_MEDICAL_DIAGNOSIS_SUMMARIES_FAIL = 'GET_MEDICAL_DIAGNOSIS_SUMMARIES_FAIL'

export const GET_LIST_MEDICAL_PROCEDURE_REQUEST = 'GET_LIST_MEDICAL_PROCEDURE_REQUEST'
export const GET_LIST_MEDICAL_PROCEDURE_SUCCESS = 'GET_LIST_MEDICAL_PROCEDURE_SUCCESS'
export const GET_LIST_MEDICAL_PROCEDURE_FAIL = 'GET_LIST_MEDICAL_PROCEDURE_FAIL'

export const GET_MEDICAL_DOCUMENT_SICK_LETTER_REQUEST = 'GET_MEDICAL_DOCUMENT_SICK_LETTER_REQUEST'
export const GET_MEDICAL_DOCUMENT_SICK_LETTER_SUCCESS = 'GET_MEDICAL_DOCUMENT_SICK_LETTER_SUCCESS'
export const GET_MEDICAL_DOCUMENT_SICK_LETTER_FAIL = 'GET_MEDICAL_DOCUMENT_SICK_LETTER_FAIL'

export const GET_LIST_MEDICAL_LETTER_REQUEST = 'GET_LIST_MEDICAL_LETTER_REQUEST'
export const GET_LIST_MEDICAL_LETTER_SUCCESS = 'GET_LIST_MEDICAL_LETTER_SUCCESS'
export const GET_LIST_MEDICAL_LETTER_FAIL = 'GET_LIST_MEDICAL_LETTER_FAIL'

export const GET_DETAIL_MEDICAL_LETTER_REQUEST = 'GET_DETAIL_MEDICAL_LETTER_REQUEST'
export const GET_DETAIL_MEDICAL_LETTER_SUCCESS = 'GET_DETAIL_MEDICAL_LETTER_SUCCESS'
export const GET_DETAIL_MEDICAL_LETTER_FAIL = 'GET_DETAIL_MEDICAL_LETTER_FAIL'
export const GET_PATIENT_DATA_MEDICAL_LETTER_REQUEST = 'GET_PATIENT_DATA_MEDICAL_LETTER_REQUEST'
export const GET_PATIENT_DATA_MEDICAL_LETTER_SUCCESS = 'GET_PATIENT_DATA_MEDICAL_LETTER_SUCCESS'
export const GET_PATIENT_DATA_MEDICAL_LETTER_FAIL = 'GET_PATIENT_DATA_MEDICAL_LETTER_FAIL'

export const SAVE_MEDICAL_LETTER_REQUEST = 'SAVE_MEDICAL_LETTER_REQUEST'
export const SAVE_MEDICAL_LETTER_SUCCESS = 'SAVE_MEDICAL_LETTER_SUCCESS'
export const SAVE_MEDICAL_LETTER_FAIL = 'SAVE_MEDICAL_LETTER_FAIL'

export const DELETE_MEDICAL_LETTER_REQUEST = 'DELETE_MEDICAL_LETTER_REQUEST'
export const DELETE_MEDICAL_LETTER_SUCCESS = 'DELETE_MEDICAL_LETTER_SUCCESS'
export const DELETE_MEDICAL_LETTER_FAIL = 'DELETE_MEDICAL_LETTER_FAIL'

export const GET_LIST_MEDICAL_SUPPLIES_REQUEST = 'GET_LIST_MEDICAL_SUPPLIES_REQUEST'
export const GET_LIST_MEDICAL_SUPPLIES_SUCCESS = 'GET_LIST_MEDICAL_SUPPLIES_SUCCESS'
export const GET_LIST_MEDICAL_SUPPLIES_FAIL = 'GET_LIST_MEDICAL_SUPPLIES_FAIL'

export const GET_DETAIL_MEDICAL_SUPPLIES_REQUEST = 'GET_DETAIL_MEDICAL_SUPPLIES_REQUEST'
export const GET_DETAIL_MEDICAL_SUPPLIES_SUCCESS = 'GET_DETAIL_MEDICAL_SUPPLIES_SUCCESS'
export const GET_DETAIL_MEDICAL_SUPPLIES_FAIL = 'GET_DETAIL_MEDICAL_SUPPLIES_FAIL'

export const POST_MEDICAL_SUPPLIES_REQUEST = 'POST_MEDICAL_SUPPLIES_REQUEST'
export const POST_MEDICAL_SUPPLIES_SUCCESS = 'POST_MEDICAL_SUPPLIES_SUCCESS'
export const POST_MEDICAL_SUPPLIES_FAIL = 'POST_MEDICAL_SUPPLIES_FAIL'

export const PATCH_MEDICAL_SUPPLIES_REQUEST = 'PATCH_MEDICAL_SUPPLIES_REQUEST'
export const PATCH_MEDICAL_SUPPLIES_SUCCESS = 'PATCH_MEDICAL_SUPPLIES_SUCCESS'
export const PATCH_MEDICAL_SUPPLIES_FAIL = 'PATCH_MEDICAL_SUPPLIES_FAIL'

export const DELETE_MEDICAL_SUPPLIES_REQUEST = 'DELETE_MEDICAL_SUPPLIES_REQUEST'
export const DELETE_MEDICAL_SUPPLIES_SUCCESS = 'DELETE_MEDICAL_SUPPLIES_SUCCESS'
export const DELETE_MEDICAL_SUPPLIES_FAIL = 'DELETE_MEDICAL_SUPPLIES_FAIL'
